module.exports = __webpack_public_path__ + "static/img/tj_a15.e2937dad.png";